import { render } from "./UnsubscribeDigest.vue?vue&type=template&id=017d39ff"
import script from "./UnsubscribeDigest.vue?vue&type=script&lang=ts"
export * from "./UnsubscribeDigest.vue?vue&type=script&lang=ts"
script.render = render

export default script